var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 513,
    height: 342,
    viewBox: "0 0 513 342",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_301_885)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -0.00732422H513V341.993H0V-0.00732422Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512 -0.00732422H0V341.993",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.7 -0.00732422L0 194.493V341.993H206.9L513 148.493V-0.00732422H307.7Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M513 -0.00732422H385.2L0 249.393V341.993H126.2L513 91.5927V-0.00732422Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.1 186.992L172.3 210.992L204.6 188.792L191.5 225.792L222.6 249.692L183.4 248.592L170.2 285.592L159.1 247.992L119.9 246.892L152.2 224.692L141.1 186.992ZM310.6 70.7925L341.8 94.6925L374.1 72.4925L361 109.492L392.1 133.392L352.9 132.292L339.7 169.292L328.6 131.692L289.4 130.592L321.8 108.392L310.6 70.7925Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_301_885"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 513,
    height: 342,
    fill: "white",
    transform: "translate(0 -0.00732422)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKn);
export default __webpack_public_path__ + "static/media/KN.e654598a706b9e7c2a8157bf0988e1f1.svg";
export { ForwardRef as ReactComponent };